import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomerAddress } from 'api/user/customer_requests';
import { VendorProfileUpdate } from 'api/user/vendor_requests';

export interface VendorDetails {
  _id: string;
  fullName: string;
  email: string;
  phone: string;
  address: CustomerAddress;
  totalOrders: number;
  userId: string;
  totalRevenue: number;
  lastOrderDate: Date | null;
  createdAt: Date | null;
}

const initialState: VendorDetails | null = {
  fullName: '',
  _id: '',
  email: '',
  phone: '',
  userId: '',
  address: {
    street: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    phone: ''
  },
  totalOrders: 0,
  totalRevenue: 0,
  lastOrderDate: null,
  createdAt: null
};

export const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setVendorDetails: (state, action: PayloadAction<VendorDetails>) => {
      return action.payload;
    },
    updateProfileDetails: (
      state,
      action: PayloadAction<VendorProfileUpdate>
    ) => {
      state.email = action.payload.email ?? '';
      state.fullName = action.payload.fullName ?? '';
      state.phone = action.payload.phone;
      state.address = action.payload.address;
    },
    updateTotalOrders: (state, action: PayloadAction<number>) => {
      state.totalOrders = action.payload;
    },
    updateTotalRevenue: (state, action: PayloadAction<number>) => {
      state.totalRevenue = action.payload;
    },
    updateLastOrderDate: (state, action: PayloadAction<Date>) => {
      state.lastOrderDate = action.payload;
    }
  }
});

export const {
  setVendorDetails,
  updateProfileDetails,
  updateTotalOrders,
  updateTotalRevenue,
  updateLastOrderDate
} = vendorSlice.actions;
export default vendorSlice.reducer;
